// extracted by mini-css-extract-plugin
export var borderRadius = "_71-4";
export var large = "_71-3";
export var logoContainer = "_71-0";
export var nameLogo = "_71-2";
export var small = "_71-1";